// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Text, Checkbox } from 'informed';

import {
  updateRequiredImmunization,
} from '../../../actions/immunizationActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import { Error } from '../../Typography.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  activePatientId: string,
  dob: string,
  sex: string,
  requiredImmunizations: Object[],
  updateRequiredImmunization: Function,
  print: boolean,
}

class RequiredImmunizationsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.dateAdministered = moment(formValues.dateAdministered, 'DD-MM-YYYY').toISOString();
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateRequiredImmunization(this.props.activePatientId, {
      immunizationId: id,
      ...formData.values,
    });
  }

  render() {
    let { requiredImmunizations } = this.props;

    // breadcrumb: hpv-females-only
    if (this.props.sex === 'M') {
      requiredImmunizations = requiredImmunizations.filter(imm => imm.immunization !== 'HPV 1' && imm.immunization !== 'HPV 2');
    }

    if (this.props.print) {
      const now = moment();
      requiredImmunizations = requiredImmunizations.filter(imm => imm.dateDue < now);
    }

    // somewhat hacky use of age and immunization fields, include values in form but no display
    const columns = [
      {
        Header: 'Age',
        id: 'age',
        editCell: item => <span>{item.age}<Text style={{ display: 'none' }} field='age' initialValue={item.age} disabled /></span>,
        width: 120,
      },
      {
        Header: 'Immunization',
        id: 'immunization',
        editCell: item => <span>{item.immunization}<Text style={{ display: 'none' }} field='immunization' initialValue={item.immunization} disabled /></span>,
      },
      {
        Header: 'Lot #',
        id: 'lotNum',
        editCell: item => <Typeahead field='lotNum' initialValue={item.lotNum} endpoint='lotNum' />,
      },
      {
        Header: 'Date Due',
        id: 'dateDue',
        cell: item => (item.dateDue ? moment(item.dateDue).format() : '--'),
        width: 120,
      },
      {
        Header: 'Date Administered',
        id: 'dateAdministered',
        cell: (item) => {
          if (item.overridden) {
            return '(overridden)';
          }
          // overdue if no administered date and if due date earlier than now
          const overdue = !item.dateAdministered && item.dateDue < moment();
          return overdue ? <Error>-- (overdue)</Error>
            : item.dateAdministered ? moment(item.dateAdministered).format() : '--';
        },
        editCell: item => <div>
          <DateText field='dateAdministered' item={item} initEmpty={item.overridden} />
          <br />
          <Checkbox field='overridden' initialValue={item.overridden} />Override
        </div>,
        width: 130,
      },
    ];

    const everyOtherAge = ['6 weeks', '14 weeks', '9 months', '18 months', '30 months', '42 months', '54 months', '5.5 years', '6.5 years', '7.5 years', '8.5 years', '9.5 years', '10.5 years', '11.5 years', '12.5 years', '13.5 years', '14.5 years', '15.5 years', '16.5 years', '17.5 years'];
    return (
      <Table
        columns={columns}
        data={requiredImmunizations}
        handleSaveRow={this.handleSaveRow}
        style={{
          maxHeight: `${this.props.print ? '' : '70vh'}`,
        }}
        getTrProps={(state, rowInfo) => {
          if (!rowInfo) return {};
          return {
            style: {
              background: everyOtherAge.includes(rowInfo.row.age) ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.03)',
            },
          };
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  dob: state.patient.data.generalInfo.dob,
  sex: state.patient.data.generalInfo.sex,
  requiredImmunizations: state.patient.data.requiredImmunizations,
  print: state.patient.print,
});

const mapDispatchToProps = dispatch => ({
  updateRequiredImmunization:
    (patientId, immunization) => dispatch(updateRequiredImmunization(patientId, immunization)),
});

const RequiredImmunizations = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequiredImmunizationsComponent);

export default RequiredImmunizations;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/immunization/RequiredImmunizations.jsx